/** PRODUCT-3015: every excluded stream shows this line to applicants. */
export const APPLICANT_EXCLUDED_STREAM_REASON =
  "This income stream doesn't meet this property's income requirements.";

export const APPLICANT_EXCLUDED_STREAM_REASON_ES =
  "Esta fuente de ingresos no cumple con los requisitos de ingresos de esta propiedad.";

export const APPLICANT_EXCLUSION_COLUMN_HEADER = "Next steps";
export const MANAGER_EXCLUSION_COLUMN_HEADER = "Exclusion Reason(s)";

export type ExclusionDisplayStream = {
  applicantInactiveCtas?: string[];
  excludedReasons?: string[];
};

export function getExclusionColumnHeader(
  useApplicantSafeCtas: boolean
): string {
  return useApplicantSafeCtas
    ? APPLICANT_EXCLUSION_COLUMN_HEADER
    : MANAGER_EXCLUSION_COLUMN_HEADER;
}

export function shouldShowVeroIncomeStreamFootnote(
  useApplicantSafeCtas: boolean
): boolean {
  return !useApplicantSafeCtas;
}

/**
 * Items to render in the exclusion / next-steps column.
 * Applicants always see the same reason line. Managers see excludedReasons.
 */
export function getExclusionDisplayItems(
  stream: ExclusionDisplayStream,
  useApplicantFacingReason: boolean
): string[] {
  if (useApplicantFacingReason) {
    return [APPLICANT_EXCLUDED_STREAM_REASON];
  }

  return stream.excludedReasons ?? [];
}
